





















import { stringToNumber } from "@/utility/CommonHelper";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class SaturasiOksigen extends Vue {
  @Prop() setOksigen: number = null;
  @Prop() setLabel!: string;
  @Prop({ default: false }) disabled?: boolean;
  @Prop({ default: false }) readonly?: boolean;
  @Ref() readonly inputElement: HTMLInputElement;
  @Prop({ default: () => [] }) errorMessages?: string[];
  // oksigen = "";
  label = "";
  placeholder = this.setLabel;
  validasi = [v => this.cek(v) || this.msg];
  msg = null;

  mounted() {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (!this.setOksigen) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
  }

  @Watch("setOksigen")
  valOksigen(val) {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (val == "" || val == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
    this.$emit("satOksigen", val);
    this.setOksigen = val;
  }

  cek(v) {
    this.setOksigen = stringToNumber(v);

    if (Number(v) > 100) {
      this.msg = "*Saturasi Oksigen lebih dari 100%, Anda yakin?";
      return false;
    } else if (Number(v) < 0) {
      this.msg = "*Saturasi Oksigen kurang dari 0%, Anda yakin?";
      return false;
    } else return true;
  }
}
